@if (loading()) {
  <!-- A batch is rendered document by document on the server, so say how many are
       coming — "Generating document preview" alone reads as a hang on 50 notes. The
       app's global loading indicator runs alongside this. -->
  @if (reportIds().length > 1) {
    <div class="document-preview-status" i18n>
      Generating {{ reportIds().length }} documents&hellip; this can take a little while.
    </div>
  } @else {
    <div class="document-preview-status" i18n>Generating document preview&hellip;</div>
  }
}
@if (error()) {
  <div class="document-preview-status document-preview-error">
    {{ error() }}
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="reload()" i18n>Retry</button>
  </div>
}
@if (pdfSrc()) {
  <div class="document-preview-frame">
    <ngx-extended-pdf-viewer
      [src]="pdfSrc()"
      [height]="'100%'"
      [showToolbar]="false"
      [textLayer]="true"
      [page]="page()"
      (pageChange)="page.set($event)"
      [zoom]="zoom()"
      (zoomChange)="onZoomChange($event)"
      (pdfLoaded)="onPdfLoaded($event)"
    ></ngx-extended-pdf-viewer>
  </div>
}
